(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 1025px)');
  var rootSelector = '.t4s-section-header .t4s-navigation';
  var itemSelector = rootSelector + ' > .t4s-nav__ul > .t4s-type__mega';
  var readyAttribute = 'data-mc-mega-ready';
  var stateAttribute = 'data-mc-mega-state';
  var openClass = 'mc-mega-menu-open';
  var themeOpenClass = 'is-action__hover';
  var hydrationPromise = null;
  var intentTimer = null;

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll(itemSelector));
  }

  function placeholder(item) {
    return item.querySelector('.t4s-lazy_menu[data-id]');
  }

  function hasContent(item) {
    return Boolean(item.querySelector('.mc-custom-mega'));
  }

  function markReadyItems() {
    items().forEach(function (item) {
      if (!hasContent(item)) return;
      item.setAttribute(readyAttribute, 'true');
      item.setAttribute(stateAttribute, 'ready');
    });
  }

  function setExpanded(item, expanded) {
    var link = item.querySelector(':scope > a');
    if (!link) return;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeItem(item) {
    item.classList.remove(openClass);
    item.classList.remove(themeOpenClass);
    setExpanded(item, false);
  }

  function closeOthers(currentItem) {
    items().forEach(function (item) {
      if (item !== currentItem) closeItem(item);
    });
  }

  function openItem(item) {
    if (!desktopQuery.matches || !hasContent(item)) return;
    closeOthers(item);
    item.classList.add(themeOpenClass);
    item.classList.add(openClass);
    setExpanded(item, true);
  }

  function applyMarkup(markup) {
    if (!markup) return false;

    var template = document.createElement('template');
    var sources = {};
    var changed = false;
    template.innerHTML = markup;

    Array.prototype.forEach.call(
      template.content.querySelectorAll('[id^="t4s-mega-contents"]'),
      function (source) {
        sources[source.getAttribute('data-id')] = source;
      },
    );

    items().forEach(function (item) {
      var target = placeholder(item);
      var source = target && sources[target.getAttribute('data-id')];
      if (!target || !source || hasContent(item)) return;
      target.innerHTML = source.innerHTML;
      changed = true;
    });

    markReadyItems();
    return changed || items().some(hasContent);
  }

  function cacheKey() {
    var themeId = window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : 'theme';
    return 'mc-mega-menu:' + themeId;
  }

  function readCache() {
    try {
      return window.sessionStorage.getItem(cacheKey()) || '';
    } catch (error) {
      return '';
    }
  }

  function writeCache(markup) {
    try {
      window.sessionStorage.setItem(cacheKey(), markup);
    } catch (error) {}
  }

  function hydrateMenus() {
    if (!desktopQuery.matches) return Promise.resolve(false);
    if (items().length && items().every(hasContent)) {
      markReadyItems();
      return Promise.resolve(true);
    }

    var cachedMarkup = readCache();
    if (cachedMarkup && applyMarkup(cachedMarkup)) return Promise.resolve(true);
    if (hydrationPromise) return hydrationPromise;

    var route = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    hydrationPromise = window
      .fetch(route + '?section_id=mega-menu', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Mega menu request failed');
        return response.text();
      })
      .then(function (markup) {
        writeCache(markup);
        return applyMarkup(markup);
      })
      .catch(function () {
        items().forEach(function (item) {
          if (!hasContent(item)) item.setAttribute(stateAttribute, 'error');
        });
        return false;
      })
      .then(function (result) {
        hydrationPromise = null;
        return result;
      });

    return hydrationPromise;
  }

  function requestOpen(item) {
    if (!desktopQuery.matches) return;

    window.clearTimeout(intentTimer);
    item.setAttribute(stateAttribute, hasContent(item) ? 'ready' : 'loading');

    intentTimer = window.setTimeout(
      function () {
        hydrateMenus().then(function (loaded) {
          if (!loaded || (!item.matches(':hover') && !item.contains(document.activeElement)))
            return;
          window.requestAnimationFrame(function () {
            openItem(item);
          });
        });
      },
      hasContent(item) ? 0 : 45,
    );
  }

  function bindItem(item) {
    if (item.hasAttribute('data-mc-mega-bound')) return;
    item.setAttribute('data-mc-mega-bound', 'true');
    item.setAttribute(stateAttribute, hasContent(item) ? 'ready' : 'idle');
    if (hasContent(item)) item.setAttribute(readyAttribute, 'true');
    setExpanded(item, false);

    item.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'touch') return;
      requestOpen(item);
    });

    item.addEventListener('focusin', function () {
      requestOpen(item);
    });

    item.addEventListener('pointerleave', function () {
      window.clearTimeout(intentTimer);
      window.setTimeout(function () {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) closeItem(item);
      }, 180);
    });

    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) closeItem(item);
    });

    var link = item.querySelector(':scope > a');
    if (link) {
      link.addEventListener('click', function (event) {
        if (!desktopQuery.matches || hasContent(item)) return;
        event.preventDefault();
        item.setAttribute(stateAttribute, 'loading');
        hydrateMenus().then(function (loaded) {
          if (loaded) openItem(item);
        });
      });
    }
  }

  function bind() {
    document.documentElement.classList.add('mc-mega-menu-enhanced');
    items().forEach(bindItem);
    markReadyItems();
  }

  function handleDocumentPress(event) {
    if (!event.target.closest(rootSelector)) items().forEach(closeItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('pointerdown', handleDocumentPress);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(bind, 50);
  });
  window.addEventListener('pageshow', bind);
})();
